import { TCardFieldInfo } from '@/common/components/Fields/CreditCardFields/CreditCardFields.types';
import { countrySchema } from '@/common/constants/country-list';
import { requiredString } from '@/common/utils/zod';
import { z } from 'zod';

export const creditCardFormSchema = z.object({
  number: z.custom<TCardFieldInfo>((data) => {
    return data.complete;
  }, 'errors.input.required'),
  expiry: z.custom<TCardFieldInfo>((data) => {
    return data.complete;
  }, 'errors.input.required'),
  cvc: z.custom<TCardFieldInfo>((data) => {
    return data.complete;
  }, 'errors.input.required'),
  cardHolderName: requiredString,
  country: countrySchema,
  zipCode: requiredString,
});

export type TCreditCardFormSchema = z.infer<typeof creditCardFormSchema>;
